import React, { useState } from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage, handleError } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../providers/SnackBarProvider';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const SearchDiagnostic = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const snackbar = useSnackbar();
  
  const [openDialog, setOpenDialog] = useState(false);
  const [newDiagnostic, setNewDiagnostic] = useState({ name: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
      />
    </Box>
  );

  const handleOnClick = (diagnostic) => {
    const from = location.state?.from;
    const pet = location.state?.pet;
    if (from) {
      navigate(from, { state: { diagnostic, pet }, replace: true });
    }
  };

  const handleCreateNew = () => {
    setNewDiagnostic({ name: '' });
    setErrors({});
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (!isLoading) {
      setOpenDialog(false);
    }
  };

  const handleSaveDiagnostic = async () => {
    if (!newDiagnostic.name.trim()) {
      setErrors({ name: t('search.nameRequired') });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}diagnostics`,
        newDiagnostic,
        { withCredentials: true }
      );

      newDiagnostic.id = response.data.data.id;
      
      setOpenDialog(false);
      
      // Si viene de otra página, navegar de vuelta con el diagnóstico creado
      const from = location.state?.from;
      const pet = location.state?.pet;
      if (from) {
        navigate(from, { state: { diagnostic: newDiagnostic, pet }, replace: true });
      }
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <SearchPage
        fetchFunction={fetchSearchPage}
        table={'diagnostics'}
        renderItem={renderItem}
        placeholder={t('search.searchDiagnostic')}
        createNew={handleCreateNew}
      />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t('search.newDiagnostic')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="normal"
            label={t('common.nameStar')}
            value={newDiagnostic.name}
            onChange={(e) => {
              setNewDiagnostic({ ...newDiagnostic, name: e.target.value });
              if (errors.name) setErrors({});
            }}
            error={!!errors.name}
            helperText={errors.name}
            disabled={isLoading}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSaveDiagnostic();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isLoading}>
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleSaveDiagnostic}
            variant="contained"
            color="primary"
            disabled={isLoading || !newDiagnostic.name.trim()}
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            {isLoading ? t('common.saving') : t('common.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchDiagnostic;

